import { StringData } from "../..";
import { StringContext } from "../../core/StringContext";
import { StringModule } from "../../core/StringModule";

/**
 * FPS Tracker Module.
 * Displays how many times `onFrame()` is called per second.
 * Useful for debugging rendering performance or vsync issues.
 */
export class StringFPSTracker extends StringModule {
  private displayElement!: HTMLDivElement;
  private intervalId!: number;
  private frameCount = 0;

  constructor(context: StringContext) {
    super(context);
    this._type = 2;
  }

  /**
   * Initializes the visual FPS counter and update interval.
   */
  onInit(): void {
    if (this.data.system.fpsTracker) {
      this.createDisplayElement();
    }

    this.intervalId = window.setInterval(() => {
      if (this.data.system.fpsTracker) {
        this.displayElement.textContent = `FPS: ${this.frameCount}`;
      }
      this.events.emit("fps", this.frameCount);
      this.frameCount = 0;
    }, 1000);
  }

  /**
   * Increments the frame counter each frame.
   */
  onFrame(_data: StringData): void {
    this.frameCount++;
  }

  /**
   * Cleans up DOM and interval.
   */
  destroy(): void {
    clearInterval(this.intervalId);
    this.displayElement.remove();
  }

  /**
   * Creates and styles the floating FPS display.
   */
  private createDisplayElement(): void {
    const el = document.createElement("div");

    Object.assign(el.style, {
      position: "fixed",
      bottom: "10px",
      right: "10px",
      backgroundColor: "#000",
      color: "#fff",
      padding: "4px 8px",
      fontSize: "12px",
      fontFamily: "monospace",
      border: "1px solid rgba(255,255,255,0.2)",
      zIndex: "1000",
      pointerEvents: "none",
    });

    el.textContent = "FPS: 0";
    document.body.appendChild(el);

    this.displayElement = el;
  }
}
